import { render, staticRenderFns } from "./ApplyFailed.vue?vue&type=template&id=2c817689&scoped=true&"
import script from "./ApplyFailed.vue?vue&type=script&lang=js&"
export * from "./ApplyFailed.vue?vue&type=script&lang=js&"
import style0 from "./ApplyFailed.vue?vue&type=style&index=0&id=2c817689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c817689",
  null
  
)

export default component.exports